module.exports = __webpack_public_path__ + "static/img/crone_whispess.b4bdf80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/crone_whispess.png
// module id = DUux
// module chunks = 0